/* eslint-disable */
import React, { Component, } from "react";

import {
    showIntercomButton,
    hideIntercomButton,
    isIntercomButtonShown,
} from "ggApp/modules/intercom/service";

/**
 * withHidingIntercomButtonWhileMounted
 * This HOC hides Intercom button while component mounted,
 * but only if Intercom button was shown after mounting
 * @param {React.ComponentType<any>} EnhancedComponent
 * @returns HOC component
 */
function withHidingIntercomButtonWhileMounted(EnhancedComponent) {
    return class HidingIntercomWhileMountedHOC extends Component {
        constructor(props) {
            super(props);

            this.isIntercomNeedsToBeHidden = true;
        }

        componentDidMount() {
            this.isIntercomNeedsToBeHidden = isIntercomButtonShown();
            if (this.isIntercomNeedsToBeHidden) {
                hideIntercomButton();
            }
        }

        componentWillUnmount() {
            if (this.isIntercomNeedsToBeHidden) {
                showIntercomButton();
            }
        }

        render() {
            return <EnhancedComponent {...this.props} />;
        }
    };
}

export { withHidingIntercomButtonWhileMounted, };
